import { render, staticRenderFns } from "./info.vue?vue&type=template&id=4dba3350&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dba3350')) {
      api.createRecord('4dba3350', component.options)
    } else {
      api.reload('4dba3350', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=4dba3350&", function () {
      api.rerender('4dba3350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/user-manage/user-authorization/info.vue"
export default component.exports